import { render, staticRenderFns } from "./DesignArea.vue?vue&type=template&id=7bbf70dc&"
import script from "./DesignArea.vue?vue&type=script&lang=js&"
export * from "./DesignArea.vue?vue&type=script&lang=js&"
import style0 from "./DesignArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports